import { MenuOption } from './types';

// sort categories that have exact id match first, then label prefix, then alphabetically
export function optionSortScore(opt: MenuOption, lSearchStr: string): number {
  let score = 0;

  const idStr = opt.subtext?.toLowerCase() || '';
  const labelStr = opt.label?.toLowerCase() || '';
  const idMatchIndex = idStr.indexOf(lSearchStr);
  const labelMatchIndex = labelStr.indexOf(lSearchStr);

  // prefix match gets highest ranking, then by where and how much of the string matches
  if (idMatchIndex >= 0) score = (idMatchIndex === 0 ? 100 : 50) - (idStr.length - lSearchStr.length) - idMatchIndex;
  // label match gets slightly lower ranking than id match
  else if (labelMatchIndex >= 0)
    score = (labelMatchIndex === 0 ? 90 : 40) - Math.min(labelStr.length - lSearchStr.length, 10) - labelMatchIndex;

  return score;
}
